import { scaniaAnalyticsApiScopes, msalInstance } from '@/app/msal';

const getApiAccessToken = async (): Promise<string> => {
  const activeAccount = msalInstance.getActiveAccount();

  if (!activeAccount) {
    return '';
  }

  const response = await msalInstance.acquireTokenSilent({
    scopes: scaniaAnalyticsApiScopes,
    account: activeAccount,
  });

  return response.accessToken;
};

export default getApiAccessToken;
